import { generateFaqQuestion } from 'src/libs/faq-lib/data/generateFaqQuestion'
import { FAQTopic, FAQTopicKey } from 'src/libs/faq-lib/faq.model'

export const faqFirstStepsData: FAQTopic = {
    topicKey: FAQTopicKey.FIRST_STEPS,
    headlineTranslationKey: 'faq-first-steps-topic-headline',
    sublineTranslationKey: 'faq-first-steps-topic-subline',
    categories: [
        {
            categoryKey: 'faq-first-steps-general-questions',
            categoryTranslationKey: 'faq-general-questions',
            questions: [
                generateFaqQuestion('faq-first-steps-interest'),
                generateFaqQuestion('faq-first-steps-features'),
                generateFaqQuestion('faq-first-steps-learn-about-features'),
                generateFaqQuestion('faq-first-steps-where-dashboard'),
                generateFaqQuestion('faq-first-steps-how-dashboard'),
                generateFaqQuestion('faq-first-steps-traigo-admin'),
            ],
        },
        {
            categoryKey: 'faq-first-steps-access',
            categoryTranslationKey: 'faq-general-access',
            questions: [
                generateFaqQuestion('faq-first-steps-how-new-user'),
                generateFaqQuestion('faq-first-steps-show-user-management'),
            ],
        },
        {
            categoryKey: 'faq-first-steps-support',
            categoryTranslationKey: 'faq-general-support',
            questions: [
                generateFaqQuestion('faq-first-steps-change-language'),
                generateFaqQuestion('faq-first-steps-find-support'),
            ],
        },
    ],
}
